_ = require 'underscore'
Auth = require 'app/scripts/db/auth'
AutoInsertionView = require 'app/scripts/views/internal/autocomplete/auto-insertion-view'
CompleterUtil = require 'app/scripts/views/internal/autocomplete/completer-util'
EditableView = require 'app/scripts/views/internal/editable-view'
FormattingHelpView = require 'app/scripts/views/card/formatting-help-view'
Layout = require 'app/scripts/views/lib/layout'
PopOver = require 'app/scripts/views/lib/pop-over'
TFM = require 'app/scripts/lib/markdown/tfm'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
friendlyLinks = require 'app/scripts/views/internal/friendly-links'
getExperiment = require 'app/scripts/lib/experiments/simple-test'
l = require 'app/scripts/lib/localize'
{ Analytics } = require '@trello/atlassian-analytics'
{ mixin } = require 'app/scripts/lib/mixin_DO_NOT_USE'
template = require 'app/scripts/views/templates/description'
{ trackUe } = require '@trello/analytics'
{ getKey, Key, isForceSubmitEvent } = require '@trello/keybindings'
module.exports = mixin AutoInsertionView, CompleterUtil, class DescriptionView extends EditableView

  initialize: ({ @board, @card, @maxDescLength, @placeholderKey, @source }) ->
    super

    @hideFullDescription = @model.get('desc')?.length > @maxDescLength
    @descType = "#{@model.typeName.toLowerCase()} description"

    @makeDebouncedMethods 'render'

    @listenTo Layout, @getAutosaveEvent(), @onAutosaveEdit
    @listenTo @model, 'change:desc', @renderDebounced

  events:
    'click .js-format-help': 'openFormatHelp'
    'click .js-edit-desc': 'editDesc'
    'click .js-edit-desc-button': ->
      trackUe(@descType, 'enters', 'edit', '', '', 'by clicking on edit button', { boardid: @board.id, cardid: @card?.id })
      Analytics.sendClickedButtonEvent
        buttonName: 'editDescriptionButton'
        source: @source
        containers:
          board: { id: @board?.id }
          card: { id: @card?.id }

    'keydown .field': (e) ->
      # Override the default keydown handler for EditableView (if we don't, it
      # will close PopOvers before we have a chance to check if one is open)
      #
      # (Handle Esc on keydown instead of keyup because we won't get a keydown
      # event if the Esc happened while an IME was open)

      # Discard the draft before saving on force submit
      # Otherwise, the component is rendered before the draft is discarded
      # in the async callback, thus re-saving the draft
      if isForceSubmitEvent(e)
        @_discardDraft('desc')

      if getKey(e) == Key.Escape
        Util.stop(e)

        if PopOver.isVisible
          PopOver.hide()
          return

        # Save the drafts and put the model desc back in the draft
        # to prevent it from autosaving
        @saveDrafts()
        @$('.js-description-draft').val(@model.get('desc'))

        Analytics.sendPressedShortcutEvent
          shortcutName: 'escapeShortcut'
          keyValue: 'esc'
          source: @source
          containers:
            board: { id: @board?.id }
            card: { id: @card?.id }
          attributes:
            whileEditingDescription: true

        # Usually render fires on changes to the description, but we're
        # putting the model desc back in the description (see above) to
        # prevent the autosave. To show the "unsaved edits" dialog, we
        # have to call render here
        @render()
        return

    'keyup .field': (e) ->
      if getKey(e) == Key.Escape
        # Don't let the keyup propagate; we want to handle PopOvers differently;
        # (we wait until keydown so we won't cancel editing if a PopOver is open)
        Util.stop(e)

      @keyAutoMention(e)

    'click .js-cancel-edit': (e) ->
      Analytics.sendClickedButtonEvent
        buttonName: 'cancelEditDescriptionButton'
        source: @source
        containers:
          board: { id: @board?.id }
          card: { id: @card?.id }

      @cancelEditDesc(e, 'by clicking on cancel button')
    'click .js-desc-content.is-hide-full': ->
      trackUe(@descType, 'expands', 'description', '', '', '', { boardid: @board.id, cardid: @card?.id })
      Analytics.sendClickedButtonEvent
        buttonName: 'showFullDescriptionButton'
        source: @source
        containers:
          board: { id: @board?.id }
          card: { id: @card?.id }

      @showFullDescription()

  render: ->
    data = {}
    data.editable = @model.editable()
    data.isCardDesc = @model.typeName == 'Card'
    data.placeholderKey = @placeholderKey
    data.isTemplate =
      if data.isCardDesc
        @model.isOnBoardTemplate()
      else
        @model.isTemplate()

    @$el.html template(data)

    desc = @model.get('desc')

    descHtml = TFM.description.format(desc ? '', { textData: @model.get('descData') }).output
    $desc = @$('.js-desc')
    $desc.empty().append(descHtml).data('unmarkeddown', desc)
    $desc.find('p').attr('dir', 'auto')
    friendlyLinks $desc[0], @board

    hasDesc = !/^\s*$/.test(descHtml)
    @$('.js-show-with-desc').toggleClass('hide', !hasDesc)
    @$('.js-hide-with-desc').toggleClass('hide', hasDesc)

    descriptionDraft = @$('.js-description-draft').val()?.length > 0
    @$('.js-description-draft').addClass(@descType.split(' ').join('-'))
    @$('.js-hide-with-draft').toggleClass('hide', descriptionDraft)
    @$('.js-desc-content').toggleClass('is-hide-full', @hideFullDescription)

    @renderFormattingButton()
    @recallDrafts()

    @

  showFullDescription: ->
    @hideFullDescription = false
    @$('.js-desc-content').removeClass('is-hide-full')
    return

  editDesc: (e) ->
    Util.stop(e)
    @showFullDescription()
    @edit('desc')
    return

  cancelEditDesc: (e, method) ->
    fromEscape = method.includes('escape key')
    Analytics.sendTrackEvent
      action: 'cancelled'
      actionSubject: 'descriptionEdit'
      source: @source
      containers:
        board: { id: @board?.id }
        card: { id: @card?.id }
      attributes:
        method: if fromEscape then 'escapeKey' else 'cancelEditDescriptionButton'
    trackUe(@descType, 'cancels', 'edit', '', '', method, { boardid: @board.id, cardid: @card?.id })

    @clearEdits(e)

  expandDesc: (e) ->
    Util.stop(e)
    @showFullDescription()
    @edit('desc', false)
    return

  renderFormattingButton: ->
    localizedText = l(['view title', 'formatting help'])
    # Wrap button with longer button text only on board sidebar, where there's less horizontal space
    wrapButton = @descType == 'board description' && localizedText.length > 20
    @$('.description-edit').toggleClass('long', wrapButton)
    @$('.description-edit .helper').toggleClass('long', wrapButton)

  openFormatHelp: (e) ->
    trackUe(@descType, 'opens', 'formatting help', '', '', '', { boardid: @board.id, cardid: @card?.id })
    Analytics.sendClickedButtonEvent
      buttonName: 'formattingHelpDescriptionButton'
      source: @source
      containers:
        board: { id: @board?.id }
        card: { id: @card?.id }
    PopOver.toggle
      elem: @$('.js-format-help')
      view: FormattingHelpView
      options: { @model, @modelCache }
      keepEdits: true
    false

  # Autosave

  getAutosaveEvent: ->
    return "autosave#{@model.typeName}Description"

  onAutosaveEdit: ($target) ->
    @hideFullDescription = false
    @commitEdits(null, $target)

  commitEdits: ->
    isEditing = @$('.description-title .editing').length
    if isEditing
      Auth.me().editing({ idBoard: @board.id })
      # Show 'Edit' button upon saving description
      @$('.description-title .editing').removeClass('editing')
      trackUe(@descType, 'saves', 'description', '', '', '', { boardid: @board.id, cardid: @card?.id })

      if !@card && @board
        Analytics.sendUpdatedBoardFieldEvent
          field: 'description'
          source: @source
          containers:
            board: { id: @board?.id }
            card: { id: @card?.id }
      else
        Analytics.sendTrackEvent
          action: 'updated'
          actionSubject: 'description'
          source: @source
          containers:
            board: { id: @board?.id }
            card: { id: @card?.id }
          attributes:
            updatedOn: 'card'

      # Discard the draft before autosaving
      # Otherwise, the component is rendered before the draft is discarded
      # in the async callback, thus re-saving the draft
      @_discardDraft('desc')

      super

  # Auto Completer

  getTextInput: ->
    descInput = @$('.js-description-draft:visible')
    if descInput.length
      return descInput

  getMentionTarget: ->
    descInput = @$('.js-description-draft:visible')
    if descInput.length
      return descInput[0]

  getEmojiTarget: ->
    descInput = @$('.js-description-draft:visible')
    if descInput.length
      return descInput[0]
